export default __webpack_public_path__ + "static/media/blank.d0faeb06.jpg";